import type { RequestSpec } from '@/types';

export function generatePhp(url: string, spec: RequestSpec, hasAuth: boolean): string {
  const hasBody = spec.body !== undefined && spec.method !== 'GET' && spec.method !== 'DELETE';
  const bodyVar = hasBody ? `$payload = ${phpRepr(spec.body, 0)};\n` : '';
  const headerLines: string[] = [`'Accept: application/json'`];
  if (hasAuth) headerLines.push(`'Authorization: Bearer ' . $accessToken`);
  if (hasBody) headerLines.push(`'Content-Type: application/json'`);

  return `<?php

$accessToken = getenv('LIBERTIFY_TOKEN');
${bodyVar}
$ch = curl_init('${url}');
curl_setopt_array($ch, [
    CURLOPT_RETURNTRANSFER => true,
    CURLOPT_CUSTOMREQUEST => '${spec.method}',
    CURLOPT_HTTPHEADER => [
        ${headerLines.join(',\n        ')},
    ],
${hasBody ? "    CURLOPT_POSTFIELDS => json_encode($payload),\n" : ''}]);

$response = curl_exec($ch);
$status = curl_getinfo($ch, CURLINFO_HTTP_CODE);
curl_close($ch);

$data = json_decode($response, true);
print_r($data);`;
}

function phpRepr(value: unknown, indent: number): string {
  const pad = '    '.repeat(indent);
  const innerPad = '    '.repeat(indent + 1);

  if (value === null || value === undefined) return 'null';
  if (typeof value === 'boolean') return value ? 'true' : 'false';
  if (typeof value === 'number') return String(value);
  if (typeof value === 'string') return `'${value.replace(/\\/g, '\\\\').replace(/'/g, "\\'")}'`;

  if (Array.isArray(value)) {
    if (value.length === 0) return '[]';
    const items = value.map((v) => `${innerPad}${phpRepr(v, indent + 1)}`).join(",\n");
    return `[\n${items},\n${pad}]`;
  }

  if (typeof value === 'object') {
    const entries = Object.entries(value as Record<string, unknown>);
    if (entries.length === 0) return '[]';
    const items = entries
      .map(([k, v]) => `${innerPad}'${k}' => ${phpRepr(v, indent + 1)}`)
      .join(',\n');
    return `[\n${items},\n${pad}]`;
  }

  return 'null';
}
